export default __webpack_public_path__ + "static/media/loader-bodymood.6e5457a1.gif";